<template>
  <div class="main-body">
    <h2>FilmHive</h2>
    <h3><span class="flame-icon">🔥</span> Movies</h3>

    <div class="movie-grid">
      <div
        class="movie-card"
        v-for="movie in movies"
        :key="movie.id"
        @click="goToMovie(movie.id)"
      >
        <img
          :src="movie.poster_path
            ? `https://image.tmdb.org/t/p/w500${movie.poster_path}`
            : 'https://via.placeholder.com/500x750?text=No+Image'"
          :alt="movie.title"
        />
        <h4>{{ movie.title }}</h4>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MainBody",
  props: ["searchQuery"], // Expects { query, genre }
  data() {
    return {
      movies: [],
      page: 1,
      loading: false,
      totalPages: null
    };
  },
  watch: {
    searchQuery: {
      immediate: true,
      handler() {
        this.page = 1;
        this.movies = [];
        this.fetchMovies();
      }
    }
  },
  async mounted() {
    await this.fetchMovies();
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeUnmount() { // ✅ changed from beforeDestroy
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    async fetchMovies() {
      if (this.loading) return;
      this.loading = true;

      let endpoint;

      if (!this.searchQuery || (!this.searchQuery.query && !this.searchQuery.genre)) {
        endpoint = `https://api.themoviedb.org/3/discover/movie?api_key=032df6282bf9cdfb83732001903e8c27&language=en-US&page=${this.page}`;
      } else if (this.searchQuery.query) {
        endpoint = `https://api.themoviedb.org/3/search/movie?api_key=032df6282bf9cdfb83732001903e8c27&language=en-US&page=${this.page}&query=${encodeURIComponent(this.searchQuery.query)}`;
      } else if (this.searchQuery.genre) {
        endpoint = `https://api.themoviedb.org/3/discover/movie?api_key=032df6282bf9cdfb83732001903e8c27&language=en-US&page=${this.page}&with_genres=${this.searchQuery.genre}`;
      }

      try {
        const res = await fetch(endpoint);
        const data = await res.json();
        this.movies = [...this.movies, ...data.results];
        this.totalPages = data.total_pages;
        this.page++;
      } catch (error) {
        console.error("Error fetching movies:", error);
      } finally {
        this.loading = false;
      }
    },
    handleScroll() {
      const scrollTop = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;

      if (scrollTop + windowHeight >= documentHeight - 200) {
        this.fetchMovies();
      }
    },
    goToMovie(movieId) {
      this.$router.push(`/movie/${movieId}`);
    }
  }
};
</script>

<style scoped>
.main-body {
  padding: 20px;
}

h2 {
  margin-top: 40px;
  font-size: 50px;
  font-weight: bold;
  color: red;
  text-align: center;
}

h3 {
  font-size: 35px;
  font-weight: bold;
  color: white;
  margin-left: 20px;
  margin-bottom: 20px;
}

.flame-icon {
  color: #e74c3c;
  font-size: 1.6rem;
  margin-left: 8px;
  animation: pulseFlame 1.2s infinite alternate;
}

@keyframes pulseFlame {
  from { transform: scale(1); }
  to { transform: scale(1.2); }
}

.movie-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 20px;
}

.movie-card {
  background-color: #1a1a1a;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 8px rgba(0,0,0,0.3);
  transition: transform 0.35s ease, box-shadow 0.35s ease;
  text-align: center;
  position: relative;
}

.movie-card img {
  width: 100%;
  display: block;
  transition: transform 0.4s ease, filter 0.4s ease;
}

.movie-card h4 {
  color: white;
  padding: 10px;
  font-size: 1rem;
  position: relative;
  z-index: 2;
}

/* Hover Effect */
.movie-card:hover {
  transform: translateY(-6px) scale(1.04);
  box-shadow: 0 12px 25px rgba(255, 0, 76, 0.5);
  cursor: pointer;
}

.movie-card:hover img {
  transform: scale(1.1);
  filter: brightness(1.15) contrast(1.05);
}

/* Subtle overlay for depth */
.movie-card::before {
  content: "";
  position: absolute;
  inset: 0;
  background: radial-gradient(circle at center, rgba(255, 0, 76, 0.15), transparent 70%);
  opacity: 0;
  transition: opacity 0.4s ease;
}

.movie-card:hover::before {
  opacity: 1;
}


</style>


